import { render, staticRenderFns } from "./largeProduct.vue?vue&type=template&id=c561f3f2&scoped=true"
import script from "./largeProduct.vue?vue&type=script&lang=js"
export * from "./largeProduct.vue?vue&type=script&lang=js"
import style0 from "./largeProduct.vue?vue&type=style&index=0&id=c561f3f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561f3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c561f3f2')) {
      api.createRecord('c561f3f2', component.options)
    } else {
      api.reload('c561f3f2', component.options)
    }
    module.hot.accept("./largeProduct.vue?vue&type=template&id=c561f3f2&scoped=true", function () {
      api.rerender('c561f3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeProduct.vue"
export default component.exports